import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    description: {
      fontSize: 18,
      lineHeight: 1.5,
      fontWeight: 'normal',
      marginBottom: SMALL_MARGIN,
      color: colorsPalette.gray,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': '6',
      '-webkit-box-orient': 'vertical',
      wordBreak: 'break-word',
    },
  }),
);
export default useStyles;
